import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';
import moment from 'moment';
import {
    Card,
    CardHeader,
    CardContent,
    List,
    Divider,
    ListItem,
} from '@mui/material';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useSelector } from 'react-redux';




const useStyles = makeStyles(() => ({
    root: {
        boxShadow: '0 4px 12px 0 rgba(0,0,0,0.05)',
        borderRadius: 8
    },
    progess: {
        position: 'absolute'
    },
    table: {
        minWidth: 700,
    },
    dishName: {
        fontWeight: 'bold',
        marginBottom: 2
    },
    dishAltName: {
        fontStyle: 'italic',
        color: '#666',
        fontSize: '0.9rem',
        marginBottom: 2
    },
    dishDescription: {
        fontSize: '0.85rem',
        color: '#555',
        marginTop: 4,
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden'
    },
    itemCell: {
        minWidth: 240,
        maxWidth: 360
    },
    tableHeader: {
        backgroundColor: '#f5f5f5',
        fontWeight: 'bold'
    },
    tableCell: {
        padding: '12px 16px',
        verticalAlign: 'top'
    },
    cardHeader: {
        backgroundColor: '#f9f9f9',
        padding: '16px 24px'
    },
    cardContent: {
        padding: '16px'
    },
    tableContainer: {
        boxShadow: '0 2px 8px 0 rgba(0,0,0,0.03)',
        borderRadius: 4,
        overflow: 'hidden'
    }
}));

const OrderDetail = props => {
    const { className, order, ...rest } = props;

    const classes = useStyles();


    // const order = useSelector((state) => state.restaurant.selectedOrder);

    const user = useSelector((state) => state.account.user);
  const currencySymbol = (user && user.currencySymbol) ? user.currencySymbol : "$";


    const itemTotal = () => {
        // Handle online orders (order.order.items)
        if (order && order.order && order.order.items) {
            return order.order.items.filter((item) => item.dish?.isDeletedDish !== true).reduce((count, curItem) => {
                return count + curItem.quantity * curItem.subTotal;
            }, 0);
        }
        // Handle local/till orders (order.dishes)
        if (order && order.dishes) {
            return order.dishes.reduce((count, curItem) => {
                // Use subTotal if available (includes options/sizes), otherwise use price
                const itemPrice = curItem.subTotal !== undefined ? curItem.subTotal : curItem.price;
                return count + curItem.quantity * itemPrice;
            }, 0);
        }
        return 0;
    };


    const getCustomerName = () => {
        if (order && order.user && order.user.name) {
            return order.user.name;
        }
        if (order && order.customerName) {
            return order.customerName;
        }
    };

    const getCustomerPhoneNumber = () => {
        if (order && order.user && order.user.phoneNumber) {
            return order.user.phoneNumber;
        }
        if (order && order.customerPhone) {
            return order.customerPhone;
        }
    };

    const getCustomerEmail = () => {
        if (order && order.user && order.user.email) {
            return order.user.email;
        }
        if (order && order.customerEmail) {
            return order.customerEmail;
        }
    };

    const getCustomerPostcode = () => {
        if (order && order.user && order.user.postcode) {
            return order.user.postcode;
        }
        if (order && order.customerPostcode) {
            return order.customerPostcode;
        }
    };

    const getCustomerAddress = () => {
        // console.log('order==', order);
        if (order && order.user && order.user.address) {
            return order.user.address;
        }
        if (order && order.customerAddress) {
            return order.customerAddress;
        }
        if (order && order.address) {
            return order.address;
        }
        return '';
    };

    const getCustomerNotes = () => {
     
        if (order && order.order && order.order.notes) {
            return order.order.notes;
        }
        return '';
    };

    const getOrderTime = () => {
        if (!order || !order.createdAt) return 'N/A';
        if (typeof order.createdAt === 'object' && '_seconds' in order.createdAt) {
            return moment(new Date(order.createdAt._seconds * 1000)).format('DD/MM/YYYY HH:mm');
        }
        return moment(order.createdAt).format('DD/MM/YYYY HH:mm');
    };

    // Online (web) orders record the customer's IP; newer ones also carry an approximate
    // location from the request's geo headers. Older online orders predate `channel`.
    const isOnlineOrder = () =>
        Boolean(order && (order.channel === 'web' || (order.order && order.order.items && !order.dishes)));

    const getIpLocation = () => {
        const location = order && order.ipLocation;
        if (!location) return '';
        const place = [location.city, location.region, location.country].filter(Boolean).join(', ');
        const coordinates = location.latitude && location.longitude
            ? `(${location.latitude}, ${location.longitude})`
            : '';
        return [place, coordinates].filter(Boolean).join(' ');
    };

    const getDishStatus = (row) => {
        console.log('dish==', row.dish);
        // For online orders
        if (row.dish) {
            if (row.dish.isRefunded === true) {
                return 'Refunded';
            }
            if (row.dish.isDeletedDish === true) {
                return 'Deleted';
            }
        }
        // For local orders
        if (row.isRefunded === true) {
            return 'Refunded';
        }
        return '';
    };

    const getDishName = (row) => {
      // For online orders (nested in dish object)
      if (row.dish) {
          if (row.dish.name && row.dish.name !== "") {
            return row.dish.name;
          }
          if (row.dish.foodName && row.dish.foodName !== "") {
            return row.dish.foodName;
          }
      }
      // For local orders (direct properties)
      if (row.name && row.name !== "") {
        return row.name;
      }
      if (row.foodName && row.foodName !== "") {
        return row.foodName;
      }
      return "";
    };

    const getFoodAltName = (row) => {
      // For online orders (nested in dish object)
      if (row.dish) {
          if (row.dish.altName && row.dish.altName !== "") {
            return row.dish.altName;
          }
          if (row.dish.foodAltName && row.dish.foodAltName !== "") {
            return row.dish.foodAltName;
          }
      }
      // For local orders (direct properties)
      if (row.altName && row.altName !== "") {
        return row.altName;
      }
      if (row.foodAltName && row.foodAltName !== "") {
        return row.foodAltName;
      }
      return "";
    };

    return (
        <Grid
            item
            lg={12}
            md={12}
            xl={9}
            xs={12}
        >
            <Card
                {...rest}
                className={clsx(classes.root, className)}
            >

                <CardHeader
                    subheader="Order details"
                    title={`Order Number ${order && order.id}`}
                    className={classes.cardHeader}
                />
                <Divider />
                <CardContent className={classes.cardContent}>

                    <TableContainer component={Paper} className={classes.tableContainer}>
                        <Table className={classes.table} aria-label="spanning table" sx={{ '& td, & th': { verticalAlign: 'top' } }}>
                            <TableHead>
                                <TableRow className={classes.tableHeader}>
                                    <TableCell className={classes.tableCell}>Qty.</TableCell>
                                    <TableCell className={classes.tableCell}>Item</TableCell>
                                    <TableCell align="right" className={classes.tableCell}>Price</TableCell>
                                    <TableCell className={classes.tableCell}>Status</TableCell>
                                    <TableCell className={classes.tableCell}>Tax Free</TableCell>
                                    <TableCell className={classes.tableCell}>Options</TableCell>
                                    <TableCell className={classes.tableCell}>Size</TableCell>
                                    <TableCell className={classes.tableCell}>Special Instructions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {/* Render for online orders */}
                                {order && order.order && order.order.items && order.order.items.filter(item => item.permanentDeletion !== true && item.isVoidedDish !== true).map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell className={classes.tableCell}>{row.quantity}</TableCell>
                                        <TableCell className={clsx(classes.tableCell, classes.itemCell)}>
                                            <div className={classes.dishName}>{getDishName(row)}</div>
                                            {getFoodAltName(row) && <div className={classes.dishAltName}>{getFoodAltName(row)}</div>}
                                            {row.dish.description && <div className={classes.dishDescription} title={row.dish.description}>{row.dish.description}</div>}
                                        </TableCell>
                                        <TableCell align="right" className={classes.tableCell} sx={{ whiteSpace: 'nowrap' }}>{currencySymbol}{row.dish && row.dish.price && Number(row.dish.price).toFixed(2).toString()}</TableCell>
                                        <TableCell className={classes.tableCell}>{getDishStatus(row)}</TableCell>
                                        <TableCell className={classes.tableCell}>{row.dish && row.dish.taxFree ? 'Yes' : 'No'}</TableCell>
                                        <TableCell className={classes.tableCell} style={{ minWidth: 140, maxWidth: 200 }}>
                                            <List dense
                                                disablePadding>
                                                {row.options && row.options.map(option => {
                                                    return <ListItem key={option.id} disableGutters sx={{ py: 0 }}>
                                                        {`${option.name} x ${option.quantity} ${currencySymbol}${option.price}`}
                                                    </ListItem>
                                                })}
                                            </List>

                                        </TableCell>
                                        <TableCell className={classes.tableCell} style={{ minWidth: 100, maxWidth: 160 }}>{row.size ? `${row.size.name} ${currencySymbol}${row.size.price}` : ''}</TableCell>
                                        <TableCell className={classes.tableCell} style={{ minWidth: 140, maxWidth: 220 }}>{row.specialInstructions}{row.specialString && row.specialString} </TableCell>
                                    </TableRow>
                                ))}
                                {/* Render for local/till orders */}
                                {order && order.dishes && order.dishes.map((row) => (
                                    <TableRow key={row.id}>
                                        <TableCell className={classes.tableCell}>{row.quantity}</TableCell>
                                        <TableCell className={clsx(classes.tableCell, classes.itemCell)}>
                                            <div className={classes.dishName}>{row.name || row.foodName}</div>
                                            {(row.altName || row.foodAltName) && <div className={classes.dishAltName}>{row.altName || row.foodAltName}</div>}
                                            {row.description && <div className={classes.dishDescription} title={row.description}>{row.description}</div>}
                                        </TableCell>
                                        <TableCell align="right" className={classes.tableCell} sx={{ whiteSpace: 'nowrap' }}>{currencySymbol}{row.price && Number(row.price).toFixed(2).toString()}</TableCell>
                                        <TableCell className={classes.tableCell}>{row.isRefunded ? 'Refunded' : ''}</TableCell>
                                        <TableCell className={classes.tableCell}>{row.taxFree ? 'Yes' : 'No'}</TableCell>
                                        <TableCell className={classes.tableCell} style={{ minWidth: 140, maxWidth: 200 }}>
                                            <List dense disablePadding>
                                                {row.options && row.options.map(option => {
                                                    return <ListItem key={option.id} disableGutters sx={{ py: 0 }}>
                                                        {`${option.name} x ${option.quantity} ${currencySymbol}${option.price}`}
                                                    </ListItem>
                                                })}
                                            </List>
                                        </TableCell>
                                        <TableCell className={classes.tableCell} style={{ minWidth: 100, maxWidth: 160 }}>{row.size ? `${row.size.name} ${currencySymbol}${row.size.price}` : ''}</TableCell>
                                        <TableCell className={classes.tableCell} style={{ minWidth: 140, maxWidth: 220 }}>{row.specialInstructions || ''}</TableCell>
                                    </TableRow>
                                ))}

                                <TableRow>
                                    <TableCell className={classes.tableCell} colSpan="2">Subtotal</TableCell>
                                    <TableCell align="right" className={classes.tableCell} colSpan={6}>{currencySymbol}{itemTotal().toFixed(2).toString()}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableCell}>Table</TableCell>
                                    <TableCell align="left" className={classes.tableCell}>
                                      {(order && order.restaurant && order.restaurant.tableId) || (order && (order.tableNumber || order.tableNo)) || ''}
                                    </TableCell>
                                    <TableCell className={classes.tableCell}>Choose Time</TableCell>
                                    <TableCell align="left" className={classes.tableCell}>{order && order.order && order.order.pickupTime}</TableCell>
                                    <TableCell className={classes.tableCell}>Choose Date</TableCell>
                                    <TableCell align="left" className={classes.tableCell} colSpan={3}>{order && order.order && order.order.selectedDate}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableCell}>Order Time</TableCell>
                                    <TableCell align="left" className={classes.tableCell} colSpan={7}>{getOrderTime()}</TableCell>
                                </TableRow>
                                {isOnlineOrder() && (order.ipAddress || getIpLocation()) && (
                                    <TableRow>
                                        <TableCell className={classes.tableCell}>IP Address:</TableCell>
                                        <TableCell align="left" className={classes.tableCell} colSpan={2}>{order.ipAddress || ''}</TableCell>
                                        <TableCell className={classes.tableCell}>Location:</TableCell>
                                        <TableCell align="left" className={classes.tableCell} colSpan={4}>{getIpLocation()}</TableCell>
                                    </TableRow>
                                )}
                                <TableRow>
                                    <TableCell className={classes.tableCell}>Customer Name:</TableCell>
                                    <TableCell align="left" className={classes.tableCell}>{getCustomerName()}</TableCell>
                                    <TableCell className={classes.tableCell}>Customer PhoneNo. :</TableCell>
                                    <TableCell align="left" className={classes.tableCell}>{getCustomerPhoneNumber()}</TableCell>
                                    <TableCell className={classes.tableCell}>Customer Email:</TableCell>
                                    <TableCell align="left" className={classes.tableCell} colSpan={3}>{getCustomerEmail()}</TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell className={classes.tableCell}>Customer Postcode:</TableCell>
                                    <TableCell align="left" className={classes.tableCell}>{getCustomerPostcode()}</TableCell>
                                    <TableCell className={classes.tableCell}>Customer Address:</TableCell>
                                    <TableCell align="left" className={classes.tableCell}>{getCustomerAddress()}</TableCell>
                                    <TableCell className={classes.tableCell}>Customer Notes:</TableCell>
                                    <TableCell align="left" className={classes.tableCell} colSpan={3}>{getCustomerNotes()}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>

                </CardContent>



            </Card>
        </Grid>
    );
};

OrderDetail.propTypes = {
    className: PropTypes.string,
    order: PropTypes.object
};

export default OrderDetail;
